import { findNearest } from "geolib";

export const handleNearestPoint = (
  selectedPoint, //Punto seleccionado
  arrayCoords, //Arreglo de coordenadas en donde se buscara el punto mas cercano
  updatedCoordinates //Puntos de referencia
) => {
  let updateLandMarks = [];
  const newSelectedPoint = findNearest(selectedPoint, arrayCoords);
  if (updatedCoordinates.length === 2) {
    const initPoint = findNearest(updatedCoordinates[0], arrayCoords);
    updateLandMarks = updatedCoordinates.map((landMark, index) =>
      index === 0 ? initPoint : landMark
    );
    updateLandMarks = updateLandMarks.map((landMark, index) =>
      index === updatedCoordinates.length - 1 ? newSelectedPoint : landMark
    );
  } else {
    updateLandMarks = updatedCoordinates.map((landMark, index) =>
      index === updatedCoordinates.length - 1 ? newSelectedPoint : landMark
    );
  }
  return updateLandMarks;
};

let verifyData = /\b(km|m|min)\b/;
// Función para formatear la distancia
export const formatDistance = (distanceInMeters) => {
  if (!verifyData.test(distanceInMeters)) {
    if (distanceInMeters < 1000) {
      // Si la distancia es menor a 1 km, mostrar en metros
      const distanceInM = (distanceInMeters / 1).toFixed(1);
      return `${distanceInM} m`;
    } else {
      // Convertir a kilómetros y limitar a 1 decimal
      const distanceInKm = (distanceInMeters / 1000).toFixed(1);
      return `${distanceInKm} km`;
    }
  }
  return distanceInMeters;
};
